import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CardHeart.svg",
  "use": "CardHeart.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CardHeart.svg\"><path d=\"M45,56H19a4,4,0,0,1-4-4V12a4,4,0,0,1,4-4H45a4,4,0,0,1,4,4V52A4,4,0,0,1,45,56ZM43,26.998a5.9986,5.9986,0,0,0-11-3.312,5.9987,5.9987,0,0,0-11,3.312h0V27h0c.0018,5.6052,7.7245,10.7481,10.2233,14.5821a.9333.9333,0,0,0,1.553,0C35.2752,37.7481,42.998,32.6052,43,27h0v-.002Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol